
import Css from './Css.js'

// 时间刻度尺组件
/*
可切换刻度单位，单位切换原理：
在当前刻度单位间隔少于50px的时候，自动换成更大的刻度单位
在当前刻度单位间隔大于100px的时候，自动换成更小的刻度单位
firstMark = 0; //起始刻度
kdhm = 0; //一个刻度包括多少毫秒
kdys = 0; //按照刻度单位划分完总长后剩余的刻度余数
*/
function TimeScale(props){
  let videoTotalTime = props.tsInfo.videoTotalTime;
  let selStartTime = props.tsInfo.selStartTime || 0;
  let selEndTime = props.tsInfo.selEndTime || videoTotalTime;
  let videoSelTime = props.tsInfo.selTime;
  let middleWidth = props.tsInfo.middleWidth;
  let slideBtnWidth = 6;  //sliderBtn的宽度
  let scaleTotalWidth = middleWidth - 2*slideBtnWidth;  //刻度尺总长度
  if(selStartTime !== undefined && selEndTime !== undefined && selEndTime > selStartTime){
    videoSelTime = selEndTime - selStartTime;
  }
  let suObj = null;
  let firstScaleLeft = 0; //第一个刻度与左边的距离
  if(videoSelTime > 500 && scaleTotalWidth > 0){
    let scaleLevel = getScaleLevel(videoSelTime);
    suObj = getSpaceAndUnit(videoSelTime, selStartTime, selEndTime, scaleTotalWidth, scaleLevel);
    firstScaleLeft = suObj.firstScaleLeft;
  }
  return (
    <>
      <div
        onMouseDown={ (e)=>{ props.clickTimeScale(e) } }
        style={ Css.TimeScale(scaleTotalWidth, slideBtnWidth) }
      >
        { getItem(suObj, firstScaleLeft, scaleTotalWidth) }
      </div>
    </>
  )
}

function getItem(suObj, firstScaleLeft, scaleTotalWidth){
  if(!suObj){
    return null;
  }
  let stMark = suObj.firstMark;
  //控制最后一个刻度的位置不要显示超出范围
  let lastSpanMarginLeft = 0;
  let tmp = scaleTotalWidth - ((suObj.num-1)*suObj.space + firstScaleLeft);
  if(tmp < 30){
    lastSpanMarginLeft = 30 - tmp;
  }
  let itemArr = [];
  let left = firstScaleLeft;
  for(let i=suObj.num-1; i>=0; i--){
    let isLastOne = false;
    let isFirstOne = true;
    if(i === 0){
      isLastOne = true;
    }
    if(i === suObj.num-1){
      isFirstOne = true;
    }else{
      isFirstOne = false;
    }
    if(!isFirstOne){
      left += suObj.space;
    }
    const txt = stMark + suObj.unit;
    itemArr.push(
      <div key={Math.random()} style={ Css.ScaleItem(suObj, isLastOne, isFirstOne, firstScaleLeft, left) }>
        <span style={ Css.ItemSp1(isLastOne, lastSpanMarginLeft) }> { txt } </span>
        <span style={ Css.ItemSp2(isLastOne) }></span>
      </div>
    )
    if((stMark + "").indexOf(".") >= 0){
      stMark = parseFloat(stMark) + suObj.step;
      stMark = parseFloat(stMark).toFixed(1);
    }else{
      stMark += suObj.step;
    }
  }
  return itemArr;
}

//根据时长和宽度，获取刻度间隔、刻度单位、刻度步长
//videoSelTime: 视频时长(指选中范围包括的时长)
//middleWidth: 刻度尺总宽度
//scaleLevel: 可选参，标记具体需要使用哪个层级的刻度单位匹配计算
function getSpaceAndUnit(videoSelTime, selStartTime, selEndTime, scaleTotalWidth, scaleLevel){
  const spaceUnit = spaceUnitArr[scaleLevel];
  let tmpLevel = scaleLevel;
  let deciSpace = 0;
  if(videoSelTime >= spaceUnit.time){ 
    let spaceUnitMillisecond = 0;
    if(spaceUnit.unit === 'm'){
      spaceUnitMillisecond = spaceUnit.step*60*1000
    }else{
      spaceUnitMillisecond = spaceUnit.step*1000
    }
    let totalSpace = videoSelTime/spaceUnitMillisecond; //如9.6个刻度
    let flagNum = parseInt((totalSpace + "").split(".")[0]);
    let deciNum = parseFloat("0." + (totalSpace + "").split(".")[1]);
    //计算非整数部分的刻度需要占据多少个px
    deciSpace = parseInt((deciNum/totalSpace)*scaleTotalWidth);
    let space = (scaleTotalWidth - deciSpace)/flagNum;  //刻度间隔px

    //如果已经切分到最小单位(0.1s)则直接返回
    if(spaceUnit.unit === 's' && spaceUnit.step === 0.1){
      let kdhm = 100;
      if(Math.floor((kdhm*(flagNum+1)+selStartTime)/100) <= (selEndTime/100)){
        flagNum = flagNum + 1;
      }
      let firstMark = (selStartTime/1000).toFixed(1);
      if(firstMark*1000 < selStartTime){
        firstMark = ((firstMark*1000 + 100)/1000).toFixed(1);
      }
      let firstScaleLeft = Math.floor(((firstMark*1000 - selStartTime)/kdhm)*space);
      let res = {
        space: space,
        unit: spaceUnit.unit,
        step: spaceUnit.step,
        deciSpace: deciSpace,
        num: flagNum,
        firstScaleLeft: firstScaleLeft,
        kdhm: kdhm,
        firstMark: firstMark
      };
      return res;
    }
    //确保计算出来的刻度相隔40px-120px
    if(space >= 40 && space < 120){
      let kdhm = 0;
      if(spaceUnit.unit === "m"){
        kdhm = spaceUnit.step * 60 * 1000;
      }else{
        kdhm = spaceUnit.step * 1000;
      }
      let firstMark = 0;
      if(spaceUnit.unit === "m"){
        firstMark = Math.ceil(selStartTime/60/1000);
      }else{
        if(spaceUnit.step < 1){ //刻度间隔少于1秒
          firstMark = Math.floor(selStartTime/1000);
          while((firstMark*1000)<selStartTime){
            firstMark += spaceUnit.step;
          }
          if((firstMark + "").indexOf(".") >= 0){
            firstMark = parseFloat(firstMark).toFixed(1);
          }
        }else{
          firstMark = (Math.ceil(selStartTime/kdhm))*(kdhm/1000);
        }
      }
      let firstScaleLeft = Math.floor(((firstMark*1000 - selStartTime)/kdhm)*space);
      if(firstScaleLeft<=0){
        firstScaleLeft = firstMark;
      }
      //刻度补充
      if(selStartTime%kdhm === 0){
        flagNum = flagNum + 1;
      }
      let kdzc = ((firstMark*1000) + (flagNum*kdhm));//刻度总长
      // while(kdzc <= selEndTime){
      while(kdzc <= (selEndTime - selStartTime)){
        flagNum = flagNum + 1;
        kdzc = ((firstMark*1000) + (flagNum*kdhm));
      }
      let res = {
        space: space,
        unit: spaceUnit.unit,
        step: spaceUnit.step,
        deciSpace: deciSpace,
        num: flagNum,
        firstScaleLeft: firstScaleLeft,
        kdhm: kdhm,
        firstMark: firstMark
      };
      return res;
    }else{
      if(space < 40){ //刻度单位过密，需要换大单位计算
        tmpLevel--;
      }else if(space >= 120){ //刻度单位过梳，需要换小单位计算
        tmpLevel++;
      }
    }
  }else{
    tmpLevel++;
  }
  if(tmpLevel >=0 && tmpLevel<spaceUnitArr.length){
    //递归调用计算，直到算出合适的刻度为止
    return getSpaceAndUnit(videoSelTime, selStartTime, selEndTime, scaleTotalWidth, tmpLevel);
  }else{
    console.error("calc TimeScale error! tmpLevel=" + tmpLevel + " videoSelTime=" + videoSelTime);
  }
}

//单位刻度列表
const spaceUnitArr = [
  { time: 3*60*60*1000, unit: 'm', step: 30 },   //30分钟刻度
  { time: 3*60*60*1000, unit: 'm', step: 20 },   //20分钟刻度
  { time: 3*60*60*1000, unit: 'm', step: 15 },   //15分钟刻度
  { time: 3*60*60*1000, unit: 'm', step: 10 },   //10分钟刻度
  { time: 2*60*60*1000, unit: 'm', step: 20 },   //20分钟刻度
  { time: 2*60*60*1000, unit: 'm', step: 15 },   //10分钟刻度
  { time: 2*60*60*1000, unit: 'm', step: 10 },   //10分钟刻度
  { time: 1*60*60*1000, unit: 'm', step: 15 },  //15分钟刻度
  { time: 1*60*60*1000, unit: 'm', step: 10 },  //10分钟刻度
  { time: 45*60*1000, unit: 'm', step: 8 },    //8分钟刻度

  { time: 30*60*1000, unit: 'm', step: 6 },    //5分钟刻度
  { time: 30*60*1000, unit: 'm', step: 5 },    //5分钟刻度
  { time: 30*60*1000, unit: 'm', step: 3 },    //3分钟刻度
  { time: 20*60*1000, unit: 'm', step: 4 },    //4分钟刻度
  { time: 15*60*1000, unit: 'm', step: 3 },    //2分钟刻度
  { time: 15*60*1000, unit: 'm', step: 2 },    //2分钟刻度
  { time: 15*60*1000, unit: 'm', step: 1 },    //1分钟刻度
  { time: 5*60*1000, unit: 'm', step: 2 },   //1分钟刻度
  { time: 5*60*1000, unit: 'm', step: 1 },   //1分钟刻度
  { time: 5*60*1000, unit: 's', step: 45 },   //45秒刻度

  { time: 5*60*1000, unit: 's', step: 30 },   //30秒刻度
  { time: 3*60*1000, unit: 'm', step: 1 },   //40秒刻度
  { time: 3*60*1000, unit: 's', step: 50 },   //40秒刻度
  { time: 3*60*1000, unit: 's', step: 40 },   //40秒刻度
  { time: 2*60*1000, unit: 's', step: 30 },   //30秒刻度

  { time: 2*60*1000, unit: 's', step: 20 },   //20秒刻度
  { time: 2*60*1000, unit: 's', step: 15 },   //15秒刻度
  { time: 2*60*1000, unit: 's', step: 10 },   //10秒刻度
  { time: 90*1000, unit: 's', step: 15 },    //15秒刻度
  { time: 1*60*1000, unit: 's', step: 10 },  //10秒刻度

  { time: 1*60*1000, unit: 's', step: 6 },   //6秒刻度
  { time: 45*1000, unit: 's', step: 8 },    //8秒刻度
  { time: 30*1000, unit: 's', step: 5 },    //5秒刻度
  { time: 30*1000, unit: 's', step: 4 },    //4秒刻度
  { time: 30*1000, unit: 's', step: 3 },    //3秒刻度

  { time: 20*1000, unit: 's', step: 4 },    //4秒刻度
  { time: 15*1000, unit: 's', step: 3 },    //3秒刻度
  { time: 15*1000, unit: 's', step: 2 },    //2秒刻度
  { time: 15*1000, unit: 's', step: 1 },    //1秒刻度
  { time: 8*1000, unit: 's', step: 2 },    //1秒刻度

  { time: 5*1000, unit: 's', step: 1 },    //1秒刻度
  { time: 5*1000, unit: 's', step: 0.5 },  //0.5秒刻度
  { time: 3*1000, unit: 's', step: 0.6 },  //0.4秒刻度
  { time: 2*1000, unit: 's', step: 0.5 },  //0.4秒刻度
  { time: 2*1000, unit: 's', step: 0.4 },  //0.4秒刻度

  { time: 2*1000, unit: 's', step: 0.3 },  //0.3秒刻度
  { time: 1*1600, unit: 's', step: 0.3 },  //0.2秒刻度
  { time: 1*1000, unit: 's', step: 0.2 },  //0.2秒刻度
  { time: 1*1000, unit: 's', step: 0.1 },  //0.1秒刻度
  { time: 0.5*1000, unit: 's', step: 0.1 },  //0.1秒刻度
];

//根据时长选取合适的刻度计算模板
const getScaleLevel = (videoSelTime) =>{
  let scaleLevel = 0;
  if(videoSelTime >= 1*60*60*1000){
    scaleLevel = 0;
  }else if(videoSelTime >= 10*60*1000){
    scaleLevel = 8;
  }else if(videoSelTime >= 2*60*1000){
    scaleLevel = 17;
  }else if(videoSelTime >= 20*1000){
    scaleLevel = 25;
  }else if(videoSelTime >= 5*1000){
    scaleLevel = 35;
  }else if(videoSelTime >= 2*1000){
    scaleLevel = 40;
  }else if(videoSelTime >= 1*1000){
    scaleLevel = 44;
  }else if(videoSelTime >= 0.5*1000){
    scaleLevel = 47;
  }
  return scaleLevel;
}

export default TimeScale;